import { LocalizedSubsectionTitle, SpacingMediumAll, SpacingMediumLeftRight } from '@mews-commander/ui';
import { Divider, Stack, Title } from '@optimus-web/core';
import { TextKey } from '@mews-commander/enums';
import { UnicodeEntity } from '@mews/enums';
import { Products } from '../ItemsOverview/Products';
import { AdditionalItems } from '../ItemsOverview/AdditionalItems';
import { ServiceName } from '../../../../../../components/commander-ui';
import { GuestCount } from './GuestCount';
import { Rates } from './Rates';
import { ResourceCategories } from './ResourceCategories';
import { ReservationStates } from './StateStatuses';
import { TimeUnitCount } from './TimeUnitCount';

export const ReservationsOverviewContent: React.FC<{ serviceId: string }> = ({ serviceId }) => (
    <Stack spacing="200" vertical>
        <SpacingMediumAll>
            <Stack>
                <Title level={3}>
                    <ServiceName id={serviceId} />
                </Title>
                {UnicodeEntity.NoBreakSpace}
                <LocalizedSubsectionTitle textKey={TextKey.ReservationPlural} />
            </Stack>
        </SpacingMediumAll>
        <SpacingMediumLeftRight>
            <TimeUnitCount serviceId={serviceId} />
        </SpacingMediumLeftRight>
        <Divider />
        <SpacingMediumLeftRight>
            <GuestCount serviceId={serviceId} />
        </SpacingMediumLeftRight>
        <Divider />
        <SpacingMediumLeftRight>
            <ResourceCategories serviceId={serviceId} />
        </SpacingMediumLeftRight>
        <Divider />
        <SpacingMediumLeftRight>
            <ReservationStates serviceId={serviceId} />
        </SpacingMediumLeftRight>
        <Divider />
        <SpacingMediumLeftRight>
            <Rates serviceId={serviceId} />
        </SpacingMediumLeftRight>
        <Divider />
        <SpacingMediumAll>
            <LocalizedSubsectionTitle textKey={TextKey.Items} />
        </SpacingMediumAll>
        <SpacingMediumLeftRight>
            <Products serviceId={serviceId} />
        </SpacingMediumLeftRight>
        <SpacingMediumLeftRight>
            <AdditionalItems serviceId={serviceId} />
        </SpacingMediumLeftRight>
    </Stack>
);
